export class PdfDocumentType {

    constructor(
        public id: number,
        public name: string
    ){}
}
